<template>
  <div>
    <FieldWrapper :field="field">
      <div class="button-group">
        <button
          v-for="option in field.options"
          :key="option.value"
          type="button"
          class="button-group__item"
          :class="{ 'button-group__item--active': isSelected(option.value) }"
          :disabled="isDisabled"
          @click="toggle(option.value)"
        >
          {{ getLabel(option.label) }}
        </button>
      </div>
    </FieldWrapper>
  </div>
</template>

<script>
import {
  base,
  eagerValidation
} from "@/components/Tools/FormHelper/Helper/mixins";
import FieldWrapper from "@/components/Tools/FormHelper/Components/FieldWrapper";
import i18n from "@/core/plugins/vue-i18n";

export default {
  components: { FieldWrapper },
  mixins: [base, eagerValidation],
  methods: {
    getLabel(label) {
      if (typeof label === "string") return label;
      return label?.[i18n.locale] || label?.en || "";
    },
    isSelected(val) {
      const current = this.value;
      if (Array.isArray(current)) {
        return current.includes(val);
      }
      return current === val;
    },
    toggle(val) {
      const current = Array.isArray(this.value) ? [...this.value] : [];

      const index = current.indexOf(val);
      if (index === -1) {
        current.push(val);
      } else {
        current.splice(index, 1);
      }

      this.value = current;
    }
  }
};
</script>

<style scoped lang="scss">
.button-group {
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--ax-border-primary, #e0e0e0);
  border-radius: 10px;
  background: var(--ax-bg-tertiary, #f5f5f5);

  &__item {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 6px 12px;
    border: none;
    border-radius: 7px;
    background: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--ax-fg-tertiary, #616161);
    cursor: pointer;
    transition: all 200ms ease-in-out;
    white-space: nowrap;

    &:hover:not(:disabled):not(.button-group__item--active) {
      color: var(--ax-fg-primary, #212121);
    }

    &--active {
      color: var(--ax-fg-primary, #212121);
      background-color: var(--ax-bg-primary, #fff);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
